
(function () {
    // Store the distributor data in window.distributors_json
    function handleData(data) {
        window.distributors_json = data;

        // Loop through all the distrib-value selectors
        document.querySelectorAll('.distrib-value').forEach((selector) => {
            const value = selector.dataset.value;
            const index = selector.dataset.index;

            // If this is the first selector, fill it with all the unique values for the selected property
            if (index === '0') {
                window.distributors_json.forEach((distributor) => {
                    fillList(selector, distributor[value]);
                });
            }

            // When the selector value changes, update the options for the next selector (if it exists)
            selector.addEventListener('change', (event) => {
                const searchButton = document.querySelector('.button-distrib-search');
                if (index === '0') {
                    // Empty the Model selector when Make selector changes
                    const modelSelector = document.querySelector('.distrib-value[data-value="Model"]');
                    modelSelector.value == '';
                    clearList(modelSelector);

                    // Disable the Engine selector if the Make selector changes
                    const engineSelector = document.querySelector('.distrib-value[data-value="Engine"]');
                    engineSelector.value == '';
                    clearList(engineSelector);
                    engineSelector.disabled = true;

                    // Disable the search button 
                    searchButton.disabled = true;

                    // Fill values to Model    
                    const nextSelector = document.querySelector(
                        `.distrib-value[data-index="${Number(index) + 1}"]`
                    );
                    // Filter the distributor data to get the unique values for the next selector
                    const filteredOptions = window.distributors_json
                        .filter((distributor) => distributor[value] == selector.value)
                        .map((distributor) => distributor[nextSelector.dataset.value]);

                    // Fill the next select with the filtered options
                    filteredOptions.forEach((optionValue) => {
                        fillList(nextSelector, optionValue);
                    });
                    nextSelector.disabled = false;
                } else if (index === '1') {
                    // Enable the Engine selector if Model selector changes
                    const engineSelector = document.querySelector('.distrib-value[data-value="Engine"]');
                    engineSelector.value == '';
                    clearList(engineSelector);
                    engineSelector.disabled = true;

                    // Disable the search button 
                    searchButton.disabled = true;

                    // Fill values to Model    
                    const nextSelector = document.querySelector(
                        `.distrib-value[data-index="${Number(index) + 1}"]`
                    );
                    const makeSelector = document.querySelector('.distrib-value[data-value="Model"]')
                    // Filter the distributor data to get the unique values for the next selector
                    const filteredOptions = window.distributors_json
                        .filter((distributor) => distributor[makeSelector.dataset.value] == makeSelector.value)
                        .filter((distributor) => distributor[value] == selector.value)
                        .map((distributor) => distributor[nextSelector.dataset.value]);

                    // Fill the next select with the filtered options
                    filteredOptions.forEach((optionValue) => {
                        fillList(nextSelector, optionValue);
                    });
                    nextSelector.disabled = false;
                } else {
                    // Enable the search button
                    searchButton.disabled = false;
                }
            });
        });

        // When the search button is clicked, display the search results
        document.querySelector('.button-distrib-search').addEventListener('click', () => {
            displayResults();
        });
    }

    // Remove all options from the given select list
    function clearList(list) {
        list.querySelectorAll('.valid-option').forEach((option) => {
            option.remove();
        });
        list.querySelector('option').selected = true;
    }

    // Add a new option to the given select list (if it doesn't already exist)
    function fillList(list, element) {
        // Only add unique values to the list
        if (!list.querySelector(`[value="${element}"]`)) {
            const option = document.createElement('option');
            option.classList = 'valid-option';
            option.value = element;
            option.innerHTML = element;

            // Check if an option with the same value already exists
            const existingOption = Array.from(list.options).find(
                (option) => option.value === element
            );

            if (!existingOption) {
                // Add the option to the list if it doesn't exist already
                list.appendChild(option);
            }
        }
    }


    function displayResults() {

        const makeSelector = document.querySelector('.distrib-value[data-value="Make"]');
        const modelSelector = document.querySelector('.distrib-value[data-value="Model"]');
        const engineSelector = document.querySelector('.distrib-value[data-value="Engine"]');
        const distributors_results = window.distributors_json
            .filter((distributor) => distributor[makeSelector.dataset.value] == makeSelector.value)
            .filter((distributor) => distributor[modelSelector.dataset.value] == modelSelector.value)
            .filter((distributor) => distributor[engineSelector.dataset.value] == engineSelector.value)
            .map((distributor) => distributor['sku']);

        const results_container = document.getElementById('distribution-product-grid');
        results_container.innerHTML = '';
        results_container.classList.add('loading');
        
        distributors_results.forEach((sku) => {
            fetch(`/search?type=product&q=variants.sku:${sku}&view=distributor`)
                .then((response) => response.text())
                .then(result => {
                    const li = document.createElement('li');
                    li.classList = 'collection-item';
                    li.innerHTML = result;
                    results_container.appendChild(li);
                    results_container.classList.remove('loading');
                });
        });

        // Show counter for products
        const count = distributors_results.length;
        const productString = count === 1 ? 'Product' : 'Products';
        document.querySelector('.product-counter').innerHTML = `${count} ${productString}`;
        
    }

    // FETCH DATA
    function handleIntersection(entries, observer) {
        entries.forEach((entry) => {
            if (entry.target.classList.contains('distributor') && entry.isIntersecting) {
                fetch(distributors_url).then((response) => response.json()).then((distributors_json) => handleData(distributors_json))
                observer.disconnect();
            }
        });
    }

    const options = {
        rootMargin: '0px',
        threshold: 0.5
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    const distributorElement = document.querySelector('.distributor');
    observer.observe(distributorElement);
})();
